import { SCol, SRow } from '@avalara/skylab-sdk/react';
import type React from 'react';

import Subtext from './order-item-subtext';

type Props = {
  name: string | null | undefined;
  price: string;
  strikethrough?: boolean;
  subtext?: string;
  // A third, smaller/muted line below subtext (e.g. "Includes Research lead agent") — see
  // OfferItem.description.
  description?: string;
  // A struck-through price shown before `price` (e.g. "$4,999.00" before "$1,999.00") — see
  // OfferOrderSummary.showInlineDiscount.
  originalPrice?: string;
  // A small pill badge next to the name (e.g. "60% online discount") — see
  // OfferOrderSummary.showInlineDiscount.
  badge?: string;
  nameStyle?: React.CSSProperties;
  priceStyle?: React.CSSProperties;
  nameSuffix?: React.ReactNode;
  // Removes both columns' default bottom padding (e.g. the Activation fee row in Order Review's
  // additionalItems, BRGUI-2975) -- separate from the subtext/description check below, which only
  // strips it from the name column and only when one of those is present.
  noPadBottom?: boolean;
};

const OrderItem = ({
  name,
  price,
  strikethrough,
  subtext,
  description,
  originalPrice,
  badge,
  nameStyle,
  priceStyle,
  nameSuffix,
  noPadBottom,
}: Props) => (
  <SRow className='pad-top-xs'>
    <SCol span='8' className={subtext || description || noPadBottom ? 'pad-bottom-none' : undefined} style={nameStyle}>
      <span>
        {name}
        {nameSuffix}
        {badge && <span className='order-review-discount-badge'>{badge}</span>}
      </span>
      {subtext && (
        <span>
          <Subtext text={subtext} />
        </span>
      )}
      {description && (
        <span className='order-review-item-description' data-ref='buy.order-summary.item-description'>
          {description}
        </span>
      )}
    </SCol>
    <SCol
      data-ref='buy.order-summary.price'
      span='4'
      style={priceStyle}
      className={`text-right${strikethrough ? ' text-strikethrough' : ''}${noPadBottom ? ' pad-bottom-none' : ''}`}
    >
      {originalPrice && <span className='order-review-item-original-price'>{originalPrice}</span>}
      <span>{price}</span>
    </SCol>
  </SRow>
);
export default OrderItem;
